module.exports = __webpack_public_path__ + "img/Arthur.a5110a4.JPG";